import {FC, ReactNode} from 'react';
import clsx from 'clsx';

export type ModalFooterProps = {
    children: ReactNode;
    className?: string;
};

const ModalFooter: FC<ModalFooterProps> = ({children, className}) => (
    <div className={clsx('px-4 pb-4 pt-2', className)}>
        <div className="flex flex-row justify-end gap-1">{children}</div>
    </div>
);

export default ModalFooter;
